import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { LoginComponent } from './login/login.component';
import { EmailValidatorDirective } from './common/directives/email-validator.directive';
import { TokenInterceptor } from './core/interceptors/token-interceptor';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomErrorHandler } from './core/handlers/custom.error.handler';
import { HavenEventDirective } from './shared/haven-event.directive';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CookieService } from 'ngx-cookie-service';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
// import { AngularFontAwesomeModule } from 'angular-font-awesome';

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        EmailValidatorDirective,
        HavenEventDirective,
        PageNotFoundComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        FormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot()], 
        providers: [
        {
            provide: ErrorHandler,
            useClass: CustomErrorHandler,
        },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        CookieService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        AutocompleteLibModule
    ] })
export class AppModule {}
